<template>
  <div>
    <div class="c-reference-news">
      <h5 v-if="noContent">{{ $t('message.not_exist') }}</h5>
      <div @click="handleDetail">{{ news.body }}</div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'ReferenceComments',
    props: {
      id: { type: Number, required: true },
    },
    data () {
      return {
        news: {},
        noContent: false,
      }
    },
    mounted () {
      this.fetchNews()
    },
    methods: {
      async fetchNews () {
        const { data: news, status } = await this.$http.get(`/comments/${this.id}`, { allow404: true })
        if (status === 404) {
          this.noContent = true
        } else {
          this.news = news
        }
      },
      handleDetail () {
        const type = this.news.commentable_type
        const data = this.news.commentable
        let path = ''
        switch (type) {
          case 'group-posts':
            path = `/groups/${data.group_id}/posts/${data.id}`
            break
          case 'feeds':
            path = `/feeds/${data.id}`
            break
          case 'news':
            path = `/news/${data.id}`
            break
          case 'question-answers':
            path = `/questions/${data.question_id}/answers/${data.id}`
            break
          default:
            break
        }
        if (path) {
          this.$router.push({
            path,
          })
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.c-reference-news {
  padding: 15px 20px;
  background-color: #f4f5f5;
  font-size: 26px;

  > a {
    display: flex;
    align-items: center;
    color: #999;
  }

  .image {
    width: 80px;
    height: 80px;
    margin-right: 15px;

    > div {
      width: 100%;
      height: 100%;
      background: no-repeat center / cover;
    }
  }

}
</style>
